import auth from '@src/redux/modules/auth';
import subscription from '@src/redux/modules/subscription';
import app from '@src/redux/modules/app';
import video from '@src/redux/modules/video';
import question from '@src/redux/modules/question';
import campaign from '@src/redux/modules/campaign';
import splash from '@src/redux/modules/splash';
import tag from '@src/redux/modules/tag';
import settings from '@src/redux/modules/settings';
import plugins from '@src/redux/modules/plugins';
import videoPage from '@src/redux/modules/videoPage';
import organization from '@src/redux/modules/organization';
import planReducer from '@src/containers/Billing/reducer';
import { campaignLandingPageReducer } from '@src/redux/modules/campaignLandingPage';
import { headerReducer } from '@src/redux/modules/header';
import { campaignEditPageReducer } from '@src/redux/modules/campaigns';
import { mediaReducer } from '@src/redux/modules/media';
import { shareReducer } from '@src/redux/modules/share';
import { tagsReducer } from '@src/redux/modules/tags';
import { campaignListPageReducer } from '@src/redux/modules/campaignList';
import { pluginCreationReducer } from '@src/redux/modules/pluginCreation';
import { videoCompilationPageReducer } from '@src/redux/modules/videoCompilationPage';
import { contactsPageReducer } from '@src/redux/modules/contacts';
import { ssembleRequestReducer } from '@src/redux/modules/ssemble';

export default {
  auth,
  subscription,
  app,
  video,
  header: headerReducer,
  question,
  campaign,
  campaignEdit: campaignEditPageReducer,
  campaignLanding: campaignLandingPageReducer,
  campaignList: campaignListPageReducer,
  splash,
  tag,
  settings,
  plugins,
  pluginCreation: pluginCreationReducer,
  videoPage,
  organization,
  plan: planReducer,
  media: mediaReducer,
  share: shareReducer,
  tags: tagsReducer,
  videoCompilation: videoCompilationPageReducer,
  contacts: contactsPageReducer,
  ssemble: ssembleRequestReducer
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js